import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  withCredentials: true,
  params: { _embed: true }
})

export default {
  getPosts ({ state, commit, getters }, options) {
    const page = options.page || 1
    const { category, tag } = options
    const params = { page }
    if (category) {
      params.categories = getters.categoryId(category)
    }
    if (tag) {
      params.tags = getters.tagId(tag)
    }
    if (!category && !tag) {
      params.sticky = false
    }
    return api.get('/wp/v2/posts', {
      params
    }).then(({ data, headers }) => {
      commit('POSTS', { data, headers })
      if (page === 1 && (!category && !tag)) {
        if (state.stickies) {
          commit('STICKY')
          return
        }
        api.get('/wp/v2/posts', {
          params: { _embed: true, sticky: true }
        }).then(({ data }) => {
          commit('STICKY', data)
        })
      }
    })
  },
  getPostBySlug ({ commit }, slug) {
    return api.get('/wp/v2/posts', {
      params: { slug }
    }).then(({ data }) => {
      commit('POST', data)
    })
  },
  getPageBySlug ({ commit }, slug) {
    return api.get('/wp/v2/pages', {
      params: { slug }
    }).then(({ data }) => {
      commit('PAGE', data)
    })
  },
  getRelated (_, { id, tags }) {
    return api.get('/wp/v2/posts', {
      params: {
        per_page: 4,
        tax_relation: 'OR',
        exclude: id,
        tags: tags.join(',')
      }
    })
  }
}
